import { render, staticRenderFns } from "./CardCollectionContent.vue?vue&type=template&id=65d704a6&scoped=true"
import script from "./CardCollectionContent.vue?vue&type=script&lang=js"
export * from "./CardCollectionContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d704a6",
  null
  
)

export default component.exports